import { getAttemptPath } from "./completions";

// Turns the end-of-session report request and its polled GET response into what the
// chatbot completion dialog shows: null (no report requested), pending, ready or unavailable.

export const SESSION_REPORT_POLL_MS = 3000;
export const SESSION_REPORT_TIMEOUT_MS = 60000;

export const isSessionReportSettled = (response) =>
  ["ready", "failed"].includes(response?.Item?.status);

// apiRequest throws `${status} ${statusText}`. A 409 means a report for this completion
// already exists, so the client keeps polling for it rather than giving up.
export const isConflictError = (error) =>
  String(error?.message || "").startsWith("409");

export const toSessionReportSummary = ({
  requested,
  requestFailed,
  timedOut,
  response,
}) => {
  if (!requested) return null;

  const item = response?.Item;
  if (item?.status === "ready" && item.report) {
    // The dialog shows only the areas of strength and growth, or the summary when the
    // session could not be assessed. The full report is on the attempt page.
    return {
      status: "ready",
      summary: item.report.summary,
      areaOfStrength: item.report.areaOfStrength ?? null,
      areaForGrowth: item.report.areaForGrowth ?? null,
    };
  }

  if (requestFailed || timedOut || item?.status === "failed") {
    return { status: "unavailable" };
  }

  return { status: "pending" };
};

// Attempt page for a chatbot completion inside a course (optionally via a classroom).
// Standalone bots have no attempt route, so there is nowhere to link to.
export const getBotAttemptPath = (args) => getAttemptPath({ ...args, exercise: "bot" });
